import React from "react";

function formatDate(dateString, type) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date = new Date(dateString);

  const monthName = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const timezone = Intl.DateTimeFormat(undefined, {
    timeZoneName: "short",
  }).format(date);

  const timeArray = timezone?.split(",");
  const zoneArray = timeArray[1]?.split("+");

  const formattedDate = `${monthName} ${day}, ${year}`;
  const formattedTimezone = ` - ${hours}:${minutes} ${
    zoneArray[0] ? zoneArray[0] : ""
  }`;

  if (type == "date") {
    const formattedDateTimezone = `${formattedDate}`;
    return formattedDateTimezone;
  } else {
    const formattedDateTimezone = `${formattedDate}  ${formattedTimezone}`;
    return formattedDateTimezone;
  }
}

const PastIncidents = ({ dates, data }) => {
  const sortedDates = [...dates].sort((a, b) => new Date(b) - new Date(a));

  return (
    <div>
      <div className="children-position" style={{ paddingRight: "8rem" }}>
        <br /> <br />
        <h1 style={{ fontSize: "1.5rem", fontWeight: "600" }}>
          Past Incidents
        </h1>
      </div>

      {sortedDates.slice(0, 15).map((date, index) => {
        const formattedDate = formatDate(date, "date");

        const incidentsForDate = data?.data?.data?.pastIncidents?.filter(
          (incident) => {
            const happenedAtDate = incident.happenedAt
              ? incident.happenedAt.split("T")[0]
              : null;
            return happenedAtDate === date;
          }
        );

        const maintenanceForDate = data?.data?.data?.pastMaintenances?.filter(
          (maintenance) => {
            const happenedAtDate = maintenance.happenedAt
              ? maintenance.happenedAt.split("T")[0]
              : null;
            return happenedAtDate === date;
          }
        );

        return (
          <div
            key={index}
            className="children-position pl-8 pr-4 pt-6"
            style={{ paddingRight: "4rem" }}
          >
            <br />
            <div style={{ display: "flex", alignItems: "left" }}></div>
            <h3 style={{ fontSize: "1.3rem", fontWeight: "400" }}>
              {formattedDate}
            </h3>
            <hr></hr>
            <br></br>
            {incidentsForDate && incidentsForDate.length > 0 ? (
              incidentsForDate.map((incident, incidentIndex) => {
                return (
                  <div
                    key={incidentIndex}
                    className="mt-6 flex flex-col space-y-4 "
                    style={{ paddingRight: "7rem" }}
                  >
                    <div className="bg-white dark:bg-slate-900 rounded-lg px-6 py-6 ring-1 ring-slate-900/5 shadow-sm border-2 border-t-orange-500">
                      <h3 className="inline-flex items-right justify-right p-2 bg-green-600 rounded-md shadow-sm text-white mt-5">
                        {incident?.incident?.name}
                      </h3>
                      {incident.updates.map((update, k) => {
                        const formattedDateTimezone = formatDate(
                          update.happenedAt
                        );
                        return (
                          <div key={k}>
                            <br />
                            <span
                              style={{
                                fontSize: "1rem",
                                fontWeight: "600",
                              }}
                              className="text-slate-900 dark:text-white mt-5 text-base font-medium tracking-tight"
                            >
                              {update.message ===
                                "We are continuing to investigate this issue." ||
                              update.message ===
                                "We are continuing to work on a fix for this issue." ||
                              update.message ===
                                "We are continuing to monitor for any further issues."
                                ? "Update - "
                                : update.status.label + " - "}
                            </span>
                            <span>{update.message}</span>
                            <br />
                            <span style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                              {formattedDateTimezone}
                            </span>
                            <br />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })
            ) : (
              <p></p>
            )}
            {maintenanceForDate && maintenanceForDate.length > 0 ? (
              maintenanceForDate.map((maintenance, maintenanceIndex) => {
                return (
                  <div
                    key={maintenanceIndex}
                    className="mt-6 flex flex-col space-y-4 "
                    style={{ paddingRight: "7rem" }}
                  >
                    <div className="bg-white dark:bg-slate-900 rounded-lg px-6 py-6 ring-1 ring-slate-900/5 shadow-sm border-2 border-t-orange-500">
                      <h3 className="inline-flex items-right justify-right p-2 bg-blue-600 rounded-md shadow-sm text-white mt-5">
                        {maintenance?.maintenance?.name}
                      </h3>
                      {maintenance.updates.map((update, k) => {
                        const formattedDateTimezone = formatDate(
                          update.happenedAt
                        );
                        return (
                          <div key={k}>
                            <br />
                            {update.status.label === "Scheduled" && (
                              <div>
                                <span
                                  style={{
                                    fontSize: "1rem",
                                    fontWeight: "600",
                                  }}
                                  className="text-slate-900 dark:text-white mt-5 text-base font-medium tracking-tight"
                                >
                                  {update.status.label}
                                </span>
                                <span>
                                  {
                                    " - The scheduled maintenance has been completed."
                                  }
                                </span>
                              </div>
                            )}
                            {update.status.label === "In Progress" && (
                              <div>
                                <span
                                  style={{
                                    fontSize: "1rem",
                                    fontWeight: "600",
                                  }}
                                  className="text-slate-900 dark:text-white mt-5 text-base font-medium tracking-tight"
                                >
                                  {update.status.label}
                                </span>
                                <span>
                                  {
                                    " - Scheduled maintenance is currently in progress. We will provide updates as necessary."
                                  }
                                </span>
                              </div>
                            )}
                            {update.status.label === "Completed" && (
                              <div>
                                <span
                                  style={{
                                    fontSize: "1rem",
                                    fontWeight: "600",
                                  }}
                                  className="text-slate-900 dark:text-white mt-5 text-base font-medium tracking-tight"
                                >
                                  {update.status.label}
                                </span>
                                <span>
                                  {
                                    " - The scheduled maintenance has been completed."
                                  }
                                </span>
                              </div>
                            )}
                            <span style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                              {formattedDateTimezone}
                            </span>
                            <br />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })
            ) : (
              <p></p>
            )}

            {incidentsForDate &&
              incidentsForDate.length <= 0 &&
              (!maintenanceForDate || maintenanceForDate.length <= 0) && (
                <p>No incidents reported.</p>
              )}
          </div>
        );
      })}
    </div>
  );
};

export default PastIncidents;
